const lifestyleImg =
    "https://images.unsplash.com/photo-1716475816753-0a61b8fb13bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBjb3VwbGUlMjBzdW5zZXR8ZW58MHx8fHwxNzc4NDg2ODA2fDA&ixlib=rb-4.1.0&q=85";

const beliefs = [
    "We believe dating apps broke something quietly.",
    "Five carefully chosen humans beats infinite scrolling. Every time.",
    "Compatibility is more than face cards. It's twelve quiet things.",
    "The best dating app is one you can delete because it worked.",
];

export default function About() {
    return (
        <section
            id="about"
            className="relative py-28 lg:py-36 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]"
            data-testid="about-section"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="reveal flex items-end justify-between flex-wrap gap-6 mb-16">
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] mb-4">
                            Sect. F — The Manifesto
                        </div>
                        <h2 className="font-display text-6xl lg:text-[9rem] leading-[0.85] tracking-tighter">
                            A small{" "}
                            <span className="font-italic-serif text-[var(--hot)]">
                                rebellion
                            </span>
                            <br /> against swipe culture.
                        </h2>
                    </div>
                </div>

                <div className="grid lg:grid-cols-[1.1fr_1fr] gap-14 items-start">
                    {/* Big editorial image */}
                    <div className="reveal relative h-[480px] lg:h-[640px] border-2 border-[var(--ink)] overflow-hidden">
                        <img
                            src={lifestyleImg}
                            alt="Two people sharing a quiet moment at sunset"
                            className="absolute inset-0 w-full h-full object-cover"
                            style={{ filter: "saturate(0.7) contrast(1.05)" }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/70 via-transparent to-transparent" />
                        <div className="absolute top-5 left-5 stamp bg-[var(--paper)] text-[var(--ink)]">
                            Mission · 2026
                        </div>
                        <div className="absolute bottom-6 left-6 right-6 text-[var(--paper)]">
                            <p className="font-italic-serif text-3xl lg:text-4xl leading-tight">
                                "Cure swipe fatigue. Bring back the butterflies."
                            </p>
                            <div className="font-hand text-xl mt-3 text-[var(--hot)]">
                                — the LÜVYN founders
                            </div>
                        </div>
                    </div>

                    {/* Beliefs list */}
                    <div className="reveal">
                        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)] mb-5">
                            Four things we believe
                        </div>
                        <ul className="divide-y-2 divide-[var(--ink)] border-y-2 border-[var(--ink)]">
                            {beliefs.map((b, i) => (
                                <li
                                    key={i}
                                    className="py-6 flex gap-6 items-start"
                                >
                                    <span className="font-display text-4xl text-[var(--hot)] leading-none flex-shrink-0 w-12">
                                        {`0${i + 1}`}
                                    </span>
                                    <p className="font-display text-2xl lg:text-3xl leading-tight">
                                        {b}
                                    </p>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-10 font-hand text-2xl text-[var(--hot-dark)] leading-tight max-w-md">
                            built by people who deleted every dating app they
                            ever used, and meant it.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
